import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56f8db34")

_pushScopeId("data-v-56f8db34")
const _hoisted_1 = { class: "footer text-sm h-96 w-full" }
const _hoisted_2 = { class: "background-dotted-pattern w-full h-full flex flex-col justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "mt-5",
  href: "mailto:filipesmerker@gmail.com",
  target: "_blank"
}, " filipesmerker@gmail.com ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Made with ♥️ by Filipe Merker", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")

  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_logo, { class: "w-auto" }),
      _hoisted_3,
      _hoisted_4
    ])
  ]))
})